/* eslint-disable camelcase */

import { distanceLocalized, valueFormatted } from '../../utils/travels'

export class CriticalEventContext {
  constructor ({ average_speed = 0, average_acceleration = 0, max_acceleration = null, min_acceleration = null, distance = 0 } = {}) {
    this.averageSpeed = average_speed
    this.averageAcceleration = average_acceleration
    this.maxAcceleration = max_acceleration
    this.minAcceleration = min_acceleration
    this._distance = distance
  }

  /* TODO: introduce mixins for distance??? */
  get distance () {
    return this._distance / 1000.0
  }

  get distanceLocalized () {
    return distanceLocalized(this.distance)
  }

  fixedField (field = '') {
    if (!(field in this) || !this[field]) {
      return 0
    } else {
      return valueFormatted(this[field])
    }
  }
}
